import * as React from 'react';
import { CheckboxButton } from '@cian/ui-kit';
import { useValueController } from './hooks';
import * as styles from './CheckboxButtonGroup.css';
import { IOption, TOptionValue } from './types';

export interface ICheckboxButtonGroupProps {
  options: IOption[];
  value: TOptionValue[];
  onChange(value: TOptionValue): void;
  anyOption?: boolean;
}

export const CheckboxButtonGroup: React.VFC<ICheckboxButtonGroupProps> = props => {
  const { options, onChange } = useValueController(props);

  return (
    <div className={styles['container']}>
      {options.map(option => (
        <div className={styles['button']} key={option.value}>
          <CheckboxButton value={option.value} checked={option.checked} label={option.label} onChange={onChange} />
        </div>
      ))}
    </div>
  );
};
